var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3334 12C23.5032 11.7994 23.7132 11.636 23.95 11.5205C24.1869 11.4049 24.4454 11.3396 24.7091 11.3287C24.9728 11.3178 25.2359 11.3616 25.4816 11.4573C25.7273 11.5529 25.9503 11.6984 26.1362 11.8844C26.3222 12.0703 26.4671 12.2927 26.5617 12.5374C26.6563 12.782 26.6986 13.0436 26.6858 13.3053C26.673 13.5671 26.6054 13.8233 26.4873 14.0577C26.3692 14.2921 26.2033 14.4995 26 14.6667L17 23.6667L13.3334 24.6667L14.3334 21L23.3334 12Z",
    stroke: "#EA580C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.3333L24.6667 16",
    stroke: "#EA580C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/User2.c31c804d6d6382099e568550c87b144d.svg";
export { ForwardRef as ReactComponent };